(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    /* === DOM RESTRUCTURE === */
  (function(){
    function init(){
      var wishlistEl = document.getElementById('fabWishlistShare');
      var pincodeEl = document.getElementById('fabPincode');
      var creationEl = document.getElementById('fabCreation');
      var accordionEl = document.getElementById('fabAccordion');
      var badgesEl = document.getElementById('fabProductBadges');
      var reviewsEl = document.getElementById('fabReviews');
      var subtitleEl = document.getElementById('fabSubtitle');
      if(!wishlistEl || !pincodeEl) return;

      var container = wishlistEl.closest('.product-details') || document;

      /*
       * Order: Title → Subtitle → Reviews → Badges → Price → [♡][↗][ATC] → Pincode → Creation → Accordion
       */
      var groupChildren = container.querySelector('.group-block__children, .group-block');
      if(!groupChildren) groupChildren = container;

      /* Find the title block (h1 element) */
      var titleEl = groupChildren.querySelector('h1');
      var titleBlock = null;
      if(titleEl){
        titleBlock = titleEl.closest('[class*="block"]');
        if(titleBlock && titleBlock === groupChildren) titleBlock = titleEl.parentElement;
      }

      /* Find price block */
      var priceEl = groupChildren.querySelector('.price, [class*="price-wrapper"], [class*="price_"]');
      var priceBlock = null;
      if(priceEl){
        priceBlock = priceEl.closest('[class*="block"]');
        if(priceBlock && priceBlock === groupChildren) priceBlock = priceEl.parentElement;
      }

      /* Track last inserted element to chain positions */
      var lastInserted = titleBlock;

      /* Place subtitle after title */
      if(subtitleEl && lastInserted){
        lastInserted.parentNode.insertBefore(subtitleEl, lastInserted.nextSibling);
        subtitleEl.style.display = 'block';
        lastInserted = subtitleEl;
      }

      /* Place reviews after subtitle (or after title) */
      if(reviewsEl){
        if(lastInserted){
          lastInserted.parentNode.insertBefore(reviewsEl, lastInserted.nextSibling);
        } else if(priceBlock){
          priceBlock.parentNode.insertBefore(reviewsEl, priceBlock);
        }
        reviewsEl.style.display = 'flex';
        lastInserted = reviewsEl;
      }

      /* Place badges after reviews */
      if(badgesEl){
        if(lastInserted){
          lastInserted.parentNode.insertBefore(badgesEl, lastInserted.nextSibling);
        } else if(priceBlock){
          priceBlock.parentNode.insertBefore(badgesEl, priceBlock);
        }
        badgesEl.style.display = 'flex';
      }

      /* Find buy buttons */
      var buyBtns = container.querySelector('.buy-buttons, [class*="buy-button"], product-form');
      if(!buyBtns){
        var allBtns = container.querySelectorAll('button');
        for(var i=0;i<allBtns.length;i++){
          var t = allBtns[i].textContent.trim().toLowerCase();
          if(t.indexOf('add to cart')>-1 || t.indexOf('sold out')>-1){
            buyBtns = allBtns[i].closest('[class*="block"]') || allBtns[i].parentElement.parentElement;
            break;
          }
        }
      }

      if(!buyBtns){
        wishlistEl.style.display='flex';
        pincodeEl.style.display='block';
        if(creationEl) creationEl.style.display='block';
        if(accordionEl) accordionEl.style.display='block';
        return;
      }

      var buyBlock = buyBtns.closest('[class*="block"]') || buyBtns;

      /* Create row: [heart] [share] [ADD TO CART] */
      var row = document.createElement('div');
      row.className = 'fab-buy-row';
      buyBlock.parentNode.insertBefore(row, buyBlock);
      wishlistEl.style.display = 'flex';
      row.appendChild(wishlistEl);
      row.appendChild(buyBlock);

      /* Place pincode after the row */
      pincodeEl.style.display = 'block';
      row.parentNode.insertBefore(pincodeEl, row.nextSibling);

      /* Place "Behind the Creation" after pincode */
      if(creationEl){
        creationEl.style.display = 'block';
        pincodeEl.parentNode.insertBefore(creationEl, pincodeEl.nextSibling);
      }

      /* Place accordion after creation or pincode */
      if(accordionEl){
        accordionEl.style.display = 'block';
        var afterEl = creationEl || pincodeEl;
        afterEl.parentNode.insertBefore(accordionEl, afterEl.nextSibling);
      }

      wireMobileFixedBuyRow(row);
    }

    function wireMobileFixedBuyRow(row) {
      if (!row) return;
      var mq = window.matchMedia('(max-width: 749px)');
      function apply() {
        if (mq.matches) {
          row.classList.add('fab-buy-row--mobile-fixed');
          document.body.classList.add('fab-pdp-mobile-fixed-buy');
        } else {
          row.classList.remove('fab-buy-row--mobile-fixed');
          document.body.classList.remove('fab-pdp-mobile-fixed-buy');
        }
      }
      apply();
      if (mq.addEventListener) {
        mq.addEventListener('change', apply);
      } else if (mq.addListener) {
        mq.addListener(apply);
      }
    }

    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',function(){ setTimeout(init,150); });
    } else {
      setTimeout(init,150);
    }
  })();

  /* === WISHLIST === */
  (function(){
    function init(){
      var btn = document.querySelector('.fab-ws__wishlist');
      if(!btn) return;
      var handle = btn.getAttribute('data-product-handle');
      var wl = JSON.parse(localStorage.getItem('fabelle_wishlist')||'[]');
      if(wl.indexOf(handle)>-1) btn.classList.add('is-active');
      btn.addEventListener('click',function(){
        var w = JSON.parse(localStorage.getItem('fabelle_wishlist')||'[]');
        var i = w.indexOf(handle);
        if(i>-1){ w.splice(i,1); btn.classList.remove('is-active'); }
        else { w.push(handle); btn.classList.add('is-active'); }
        localStorage.setItem('fabelle_wishlist',JSON.stringify(w));
      });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
    else init();
  })();

  /* === SHARE POPUP === */
  (function(){
    function init(){
      var btn = document.querySelector('.fab-ws__share');
      var popup = document.getElementById('fabSharePopup');
      var closeBtn = document.getElementById('fabShareClose');
      var copyBtn = document.getElementById('fabShareCopy');
      var fbLink = document.getElementById('fabShareFB');
      var twLink = document.getElementById('fabShareTW');
      var emailLink = document.getElementById('fabShareEmail');
      if(!btn || !popup) return;
      var pageUrl = encodeURIComponent(window.location.href);
      var pageTitle = encodeURIComponent(document.title);
      fbLink.href = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
      twLink.href = 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + pageTitle;
      emailLink.href = 'mailto:?subject=' + pageTitle + '&body=Check%20this%20out%3A%20' + pageUrl;
      btn.addEventListener('click', function(e){ e.stopPropagation(); popup.style.display = popup.style.display !== 'none' ? 'none' : 'block'; });
      closeBtn.addEventListener('click', function(e){ e.stopPropagation(); popup.style.display = 'none'; });
      copyBtn.addEventListener('click', function(e){ e.stopPropagation(); navigator.clipboard.writeText(window.location.href).then(function(){ copyBtn.querySelector('span').textContent = 'Copied!'; setTimeout(function(){ copyBtn.querySelector('span').textContent = 'Copy'; popup.style.display = 'none'; }, 1500); }); });
      fbLink.addEventListener('click', function(e){ e.preventDefault(); window.open(this.href, 'share', 'width=600,height=400'); popup.style.display = 'none'; });
      twLink.addEventListener('click', function(e){ e.preventDefault(); window.open(this.href, 'share', 'width=600,height=400'); popup.style.display = 'none'; });
      document.addEventListener('click', function(e){ if(!popup.contains(e.target) && e.target !== btn && !btn.contains(e.target)) popup.style.display = 'none'; });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
    else init();
  })();

  /* === PINCODE (API-integrated) === */
  (function(){
    function init(){
      var input=document.getElementById('fabPinInput');
      var btn=document.getElementById('fabPinBtn');
      if(!input||!btn) return;
      input.addEventListener('input',function(){this.value=this.value.replace(/[^0-9]/g,'');});
      input.addEventListener('keypress',function(e){if(e.key==='Enter') window.fabPinCheck();});
      btn.addEventListener('click',function(){window.fabPinCheck();});
      var saved=localStorage.getItem('fabelle_pincode');
      if(saved) input.value=saved;
    }
    window.fabPinCheck=function(){
      var input=document.getElementById('fabPinInput');
      var msg=document.getElementById('fabPinMsg');
      var btn=document.getElementById('fabPinBtn');
      var pin=input.value.trim();
      if(pin.length!==6){msg.textContent='Please enter a valid 6-digit pincode';msg.className='fab-pin__msg is-error';return;}
      msg.textContent='Checking availability...';msg.className='fab-pin__msg is-loading';btn.disabled=true;

      if(window.FabellePincodeAPI && window.FabellePincodeAPI.check){
        window.FabellePincodeAPI.check(pin).then(function(res){
          btn.disabled=false;
if (res.success) {
  var d = res.data || {};
  var _scMap = { 'FCB': 'Fabelle Café BLR', 'FCM': 'Fabelle Café MUM', 'FCC': 'Fabelle Café CHE' };
  var _sc = (d.store_code || '').toUpperCase().trim();
  var _label = _scMap[_sc] || ((d.vin_instance || '') + ' ' + (d.store_code || '')).trim();

  fabPinResult(
    true,
    'Delivering from ' + _label
  );

  /*
    Do not update #pincodeTriggerLabel here.
    FabellePincodeAPI.check(pin) already calls StoreContext.set(data).
    Header pincode-checker listens to store_context:updated and updates
    the topbar pincode with the correct font/underline style.
  */
} else {
  fabPinResult(
    false,
    res.message || 'Sorry, we do not deliver to this pincode currently.'
  );
}
        });
      } else {
        btn.disabled=false;
        msg.textContent='Pincode checker not available';msg.className='fab-pin__msg is-error';
      }
    };
    window.fabPinResult=function(ok,text){
      var msg=document.getElementById('fabPinMsg');
      var btn=document.getElementById('fabPinBtn');
      var res=document.getElementById('fabPinResult');
      msg.textContent=text;msg.className='fab-pin__msg '+(ok?'is-success':'is-error');btn.disabled=false;
      var old=res.querySelector('.fab-pin__details');if(old)old.remove();
      if(ok){var d=document.createElement('div');d.className='fab-pin__details';d.textContent='Cash on Delivery available \u2022 Free shipping on orders above \u20B92000';res.appendChild(d);}
    };
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
